import {PageType} from './Overview';
import imageFragment from 'js/graphqlFragments/ImageFragment';

export default (pageId: number, type:  PageType) =>  {
    const productTitleQuery:string = `
        product {
                ProductGlobal {
                  overviewTitleProduct
                }
            }
    `;
    const subjectMatterTitleQuery:string = `
        subjectMatter {
          SubjectMatterGlobal {
            overviewTitleSm
          }
        }
    `;
    if (type === 'Product' || type === 'SubjectMatter') {
        return (
            `
        {
            productLegacy(id: "${pageId}", idType: DATABASE_ID) {
              name
              ProductLegacyFields {
                overviewDescription
                attachedVideo {
				  videoLink
				  videoPreview {
					...ImageFragment
				  }
				}
              }
            }
            ${type === 'Product' ? productTitleQuery : subjectMatterTitleQuery}
        }
        ${imageFragment()} 
        `
        );
    }
    if (type === 'SelfLearning') {
        return `{
            post(id: "${pageId}", idType: DATABASE_ID) {
              SelfLearning {
                titleOverview
                descriptionOverview
              }
            }
          }`;
    }

    return '';
};
